module.exports = __webpack_public_path__ + "img/nopic.12595c79.jpg";